module.exports = __webpack_public_path__ + "img/jet6_04.8294c9de.jpg";